import { render, staticRenderFns } from "./settings-lists-clientsources.vue?vue&type=template&id=5982436d&"
import script from "./settings-lists-clientsources.ts?vue&type=script&lang=ts&"
export * from "./settings-lists-clientsources.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports